document.addEventListener("DOMContentLoaded", function () {
    const menuDetails = document.querySelectorAll('.header__inline-menu details');

    menuDetails.forEach(details => {
        const summary = details.querySelector('summary');
        const submenu = details.querySelector('ul');

        // Prevent the default <details> toggle behavior
        details.addEventListener('click', (e) => e.preventDefault());

        // Show submenu on mouseenter
        summary.addEventListener('mouseenter', () => {
            details.setAttribute('open', '');
        });

        // Hide submenu on mouseleave
        details.addEventListener('mouseleave', () => {
            details.removeAttribute('open');
        });
    });
});